import { useCallback } from "react";
import { useAtomValue } from "jotai";
import { Button, Tooltip } from "@zapier/design-system-beta";
import { Icon } from "@zapier/design-system";
import styles from "./ToggleStepDetailsButton.module.css";
import { hasStreamingProgressStartedAtom } from "@zapier/canvas-state";

export type AssetType = "table" | "interface";

type Props = {
  assetType?: AssetType;
  isExpanded: boolean;
  setIsExpanded?: (isExpanded: boolean) => void;
  isDisabled?: boolean;
  isLoading?: boolean;
};

export function ToggleStepDetailsButton({
  assetType,
  isDisabled,
  isExpanded,
  setIsExpanded,
  isLoading,
}: Props) {
  const hasStreamingProgressStarted = useAtomValue(
    hasStreamingProgressStartedAtom,
  );

  const onPress = useCallback(() => {
    if (setIsExpanded) {
      setIsExpanded(!isExpanded);
    }
  }, [isExpanded, setIsExpanded]);

  function ToggleButton() {
    return (
      <div className={styles.buttonWrapper}>
        <Button
          isLoading={isLoading}
          onPress={onPress}
          variant="ghost"
          size="compact"
          className={styles.button}
          isDisabled={isDisabled}
        >
          <Icon
            name={
              isDisabled
                ? "actionLock"
                : isExpanded
                  ? "arrowSmallUp"
                  : "arrowSmallDown"
            }
            size={30}
          />
          <span className={styles.text}>
            {isExpanded ? "Hide" : "Show"}&nbsp;details
          </span>
        </Button>
      </div>
    );
  }
  if (hasStreamingProgressStarted) {
    return null;
  }

  if (isDisabled) {
    return (
      <Tooltip
        placement="top"
        content={`You don't have access to this ${assetType}`}
      >
        <Tooltip.FocusableTrigger>
          <ToggleButton />
        </Tooltip.FocusableTrigger>
      </Tooltip>
    );
  }
  return <ToggleButton />;
}
